/* ==========================================================================
   arc + hue — product page behaviour
   Variant picker, gallery, sticky add to cart, bundle total, recommendations.
   ========================================================================== */
(() => {
  const AH = window.arcHue || {};
  const money = window.arcHueHelpers ? window.arcHueHelpers.formatMoney : c => (c / 100).toFixed(2);

  document.addEventListener('DOMContentLoaded', () => {
    initGallery();
    initVariants();
    initStickyAtc();
    initWishlist();
    initBundle();
    initRecommendations();
  });

  /* ---------- Gallery ---------- */
  function initGallery() {
    const main = document.querySelector('[data-pdp-main]');
    if (!main) return;
    const img = main.querySelector('img');
    document.querySelectorAll('[data-thumb]').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('[data-thumb]').forEach(b => b.setAttribute('aria-pressed', 'false'));
        btn.setAttribute('aria-pressed', 'true');
        if (img && btn.dataset.src) {
          img.src = btn.dataset.src;
          img.srcset = '';
          img.alt = btn.dataset.alt || '';
        }
      });
    });
  }

  /* ---------- Variant picker ---------- */
  function initVariants() {
    const root = document.querySelector('[data-product-root]');
    if (!root) return;

    let variants = [];
    const dataEl = document.querySelector('[data-product-variants]');
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) { return; }

    const picker = root.querySelector('[data-variant-picker]');
    if (!picker) return;

    const selected = () => {
      const chosen = [];
      picker.querySelectorAll('.opt-group').forEach(group => {
        const active = group.querySelector('[aria-pressed="true"]');
        if (active) chosen.push(active.dataset.optionSelect);
      });
      return chosen;
    };

    picker.addEventListener('click', e => {
      const btn = e.target.closest('[data-option-select]');
      if (!btn) return;
      const group = btn.closest('.opt-group');
      group.querySelectorAll('[data-option-select]').forEach(b => b.setAttribute('aria-pressed', 'false'));
      btn.setAttribute('aria-pressed', 'true');
      const label = group.querySelector('[data-option-value]');
      if (label) label.textContent = btn.dataset.optionSelect;
      update(selected());
    });

    function update(chosen) {
      const match = variants.find(v => v.options.every((opt, i) => opt === chosen[i]));
      const idInput = root.querySelector('[data-variant-id]');
      const atc = root.querySelector('[data-atc-button]');
      const sticky = document.querySelector('[data-sticky-add]');
      const priceEls = document.querySelectorAll('[data-price]');
      const compare = root.querySelector('[data-price-compare]');
      const save = root.querySelector('[data-price-save]');
      const stock = root.querySelector('[data-stock-line]');

      if (!match) {
        if (atc) { atc.disabled = true; atc.textContent = AH.strings.unavailable || 'Unavailable'; }
        if (sticky) sticky.disabled = true;
        return;
      }

      if (idInput) idInput.value = match.id;
      priceEls.forEach(el => { el.textContent = money(match.price); });

      if (compare) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compare.hidden = false;
          compare.textContent = money(match.compare_at_price);
          if (save) { save.hidden = false; save.textContent = 'Save ' + money(match.compare_at_price - match.price); }
        } else {
          compare.hidden = true;
          if (save) save.hidden = true;
        }
      }

      if (atc) {
        atc.disabled = !match.available;
        atc.textContent = match.available ? (AH.strings.addToCart || 'Add to cart') : (AH.strings.soldOut || 'Sold out');
      }
      if (sticky) {
        sticky.disabled = !match.available;
        sticky.textContent = match.available ? (AH.strings.addToCart || 'Add to cart') : (AH.strings.soldOut || 'Sold out');
      }
      if (stock) {
        const dot = stock.querySelector('.dot');
        if (dot) dot.className = match.available ? 'dot' : 'dot dot--low';
      }

      const stickyVariant = document.querySelector('[data-sticky-variant]');
      if (stickyVariant) stickyVariant.textContent = match.title === 'Default Title' ? '' : match.title;

      const stickyCompare = document.querySelector('[data-sticky-compare]');
      if (stickyCompare) {
        const hasCompare = match.compare_at_price && match.compare_at_price > match.price;
        stickyCompare.hidden = !hasCompare;
        if (hasCompare) stickyCompare.textContent = money(match.compare_at_price);
      }

      // Keep the URL shareable and the back button honest.
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
  }

  /* ---------- Sticky add to cart ---------- */
  function initStickyAtc() {
    const anchor = document.querySelector('[data-atc-anchor]');
    const sticky = document.querySelector('.sticky-atc');
    if (!anchor || !sticky) return;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        sticky.dataset.show = String(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
    }

    // Keep the two quantity steppers in step, then submit the real form.
    const mainQty = document.querySelector('#Quantity');
    const stickyQty = sticky.querySelector('#StickyQuantity');
    if (mainQty && stickyQty) {
      stickyQty.value = mainQty.value;
      mainQty.addEventListener('change', () => { stickyQty.value = mainQty.value; });
      stickyQty.addEventListener('change', () => { mainQty.value = stickyQty.value; });
    }

    sticky.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
      if (mainQty && stickyQty) mainQty.value = stickyQty.value;
      document.querySelector('#ProductForm [type="submit"]')?.click();
    });
  }

  /* ---------- Wishlist (local to the browser) ---------- */
  function initWishlist() {
    document.querySelectorAll('[data-wish]').forEach(btn => {
      btn.addEventListener('click', () => {
        const on = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', String(!on));
        window.arcHueHelpers?.toast(on
          ? (AH.strings.removedFromWishlist || 'Removed from wishlist')
          : (AH.strings.savedToWishlist || 'Saved to wishlist'));
      });
    });
  }

  /* ---------- Bundle total ---------- */
  function initBundle() {
    const bundle = document.querySelector('[data-bundle]');
    if (!bundle) return;
    const boxes = bundle.querySelectorAll('input[type="checkbox"]');
    const total = bundle.querySelector('[data-bundle-total]');
    const saveLine = bundle.querySelector('[data-bundle-save]');
    const pct = Number(bundle.dataset.discount || 0);

    const recalc = () => {
      let sum = 0, n = 0;
      boxes.forEach(b => { if (b.checked) { sum += Number(b.dataset.price || 0); n += 1; } });
      const qualifies = n >= 2 && pct > 0;
      const saving = qualifies ? Math.round(sum * pct / 100) : 0;
      if (total) total.textContent = money(sum - saving);
      if (saveLine) {
        saveLine.textContent = qualifies
          ? `You save ${money(saving)} (${pct}%)`
          : (pct > 0 ? `Add 2 or more to save ${pct}%` : '');
      }
      const submit = bundle.querySelector('[type="submit"]');
      if (submit) submit.disabled = n === 0;
    };

    boxes.forEach(b => b.addEventListener('change', recalc));
    recalc();
  }

  /* ---------- Product recommendations ---------- */
  async function initRecommendations() {
    const holder = document.querySelector('[data-recommendations]');
    if (!holder || !holder.dataset.url || holder.children.length > 0) return;
    try {
      const html = await (await fetch(holder.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        holder.innerHTML = fresh.innerHTML;
        window.arcHueHelpers?.initAjaxCart();
      } else {
        holder.closest('section')?.remove();
      }
    } catch (e) {
      holder.closest('section')?.remove();
    }
  }
})();
